module.exports = __webpack_public_path__ + "media/images/ninestars/portfolio/portfolio-details-1-0714e87c8a509ff6bf7b2fa0565cafc4.jpg";